import ModalComponent from '../../../components/ModalComponent';
import Tab from '@mui/material/Tab';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { SyntheticEvent, useState } from 'react';
import LprGroupManagement from './LprGroupManagement';

interface GroupManagementModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GroupManagementModal = ({
  onClose,
  isOpen,
}: GroupManagementModalProps) => {
  const [value, setValue] = useState('1');
  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <ModalComponent
      title={'Gerenciamento de grupos'}
      onClose={onClose}
      isOpen={isOpen}
    >
      <TabContext value={value}>
        <TabList
          variant="scrollable"
          scrollButtons="auto"
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          aria-label="primary tabs example"
        >
          <Tab label="Grupo de placas" value="1" />
          <Tab label={'Grupo de faces'} value="2" disabled />
        </TabList>
        <TabPanel value="1">
          <LprGroupManagement />
        </TabPanel>
        <TabPanel value="2"></TabPanel>
      </TabContext>
    </ModalComponent>
  );
};

export default GroupManagementModal;
